//ALL API ARE FROM HERE INITIALIZE TO CALL TOKEN ONE TIME
import axios from "axios";
import { Cookies } from "react-cookie";
export const SceneURL = process.env.REACT_APP_Scene;
export const AdminURL = process.env.REACT_APP_ADMIN;
export const imagesURL =
  process.env.REACT_APP_IMAGE_URL;

//new
export let api = axios.create( {
  withCredentials: true,
  baseURL: process.env.REACT_APP_API + "/",
  headers: {
    "X-Authorization":
      "Ioxjw7iwq9UslFrrwtMlwK5CKVwrSMHzyA7UTl6SFz6t8pBDsZVxhK0nIOBfkU5G",
  },
} );

// Set the AUTH token for any request //new
api.interceptors.response.use(
  ( response ) => response,
  async ( error ) => {
    if ( error.response.status === 401 ) {
      await axios
        .get( "admin/v1/refresh-token", {
          withCredentials: true,
          baseURL: process.env.REACT_APP_API + "/",
          headers: {
            "X-Authorization":
              "Ioxjw7iwq9UslFrrwtMlwK5CKVwrSMHzyA7UTl6SFz6t8pBDsZVxhK0nIOBfkU5G",
          },
        } )
        .catch( () => {
          const cookies = new Cookies();
          cookies.remove( "session" );
          window.location.replace( "/login" );
        } );
      return axios( error.config );
    } else if ( error.response.status === 503 ) {
      // Server unavailable, display a message to the user
      return 'Server is temporarily unavailable. Please try again later.'
    } else {
      return Promise.reject( error );
    }
  }
);
